module.exports = __webpack_public_path__ + "images/unboxing_videos/cover_kanban-5fe80065d9e62f4a08f5bfb91ce0a694.png";